import styled from "styled-components";

const ProductName = styled.h1`
  margin-bottom: 16px;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
`;
export default ProductName;
